import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7c227f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-wrapper" }


import { useAppStore } from "@/stores/app";
import CloseIcon from "@/components/icons/CloseIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupTemplate',
  props: {
  width: { type: Number, default: 630 },
},
  setup(__props) {

const appStore = useAppStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "popup",
      style: _normalizeStyle(`width: ${__props.width}px;`)
    }, [
      _createElementVNode("button", {
        class: "popup__close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(appStore).closePopup && _unref(appStore).closePopup(...args)))
      }, [
        _createVNode(CloseIcon, { class: "popup__close--icon" })
      ]),
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    _createElementVNode("div", {
      class: "popup__overlay",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(appStore).closePopup && _unref(appStore).closePopup(...args)))
    })
  ]))
}
}

})